<div class="container">
  <div class="contact-container border">
    <div class="toolbar border user-toolbar">
      <!-- <div class="user-avatar" *ngIf="profile">
        <app-avatar-display [size]="'small'" [picture]="profile.picture"></app-avatar-display>
      </div> -->
    </div>

    <div>
      <mat-list class="contact-list">
        <ng-container *ngFor="let chat of chats">
          <mat-list-item
            class="contact"
            [ngClass]="isActive(chat) ? 'active-chat-user' : ''"
            style="padding: 10px 0px 10px 0px"
            (click)="setActiveChat(chat)"
            matRipple
          >
            <app-avatar-display class="contact-name" [size]="'small'" [picture]="chat.picture"></app-avatar-display>
            <div class="name contact-name" matLine>
              <span>{{ chat.name }}</span>
              <span style="font-size: 0.8em">{{ chat.profile.email }}</span>
            </div>

            <ng-container *ngIf="chat.unreadMessage.length > 0">
              <mat-icon matBadge="{{ chat.unreadMessage.length }}" matBadgeColor="warn">new</mat-icon>
            </ng-container>
          </mat-list-item>
        </ng-container>
      </mat-list>
    </div>
  </div>

  <div class="messages-container border">
    <div class="toolbar border">
      <div class="current-contact" *ngIf="activeChat">
        <p class="current-contact-name">{{ activeChat.name }}</p>
        <button class="refresh" mat-button (click)="refresh()">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>

    <fury-scrollbar #messagesScroll class="message-scroll">
      <div *ngIf="activeChat" class="messages-display">
        <div class="action-message" *ngIf="activeChat.hasPreviousMessages">
          <button class="fetch" mat-raised-button color="accent" (click)="fetchMessage()">Messages précédent</button>
        </div>

        <div *ngIf="activeChat.messages.length === 0" class="action-message">
          <p>Pas de Messages</p>
        </div>

        <div class="chat-message" *ngFor="let message of activeChat.messages">
          <app-chat-message
            [message]="message"
            [activeChat]="activeChat"
            [closeChat]="closeChat"
            [picture]="profile.picture"
            (validateDevice)="validateDevice($event)"
          ></app-chat-message>
        </div>

        <div class="action-message" *ngIf="activeChat.unreadMessage.length > 0">
          <button class="fetch" mat-raised-button color="primary" (click)="showNewMessages()">Nouveaux Messages</button>
        </div>
      </div>
    </fury-scrollbar>

    <div class="reply-display">
      <mat-progress-bar #replyProgressBar></mat-progress-bar>
      <mat-form-field class="reply-field" appearance="fill">
        <mat-label>Votre message</mat-label>
        <textarea class="reply-input" autosize matInput (keyup.enter)="send()" [formControl]="replyCtrl"></textarea>
      </mat-form-field>

      <div class="reply-actions">
        <button (click)="send()" matSuffix mat-stroked-button color="primary" [disabled]="!replyCtrl.value">
          <mat-icon color="primary">send</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
